import { render, staticRenderFns } from "./VideoWeather.vue?vue&type=template&id=da283508&scoped=true&"
import script from "./VideoWeather.vue?vue&type=script&lang=js&"
export * from "./VideoWeather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da283508",
  null
  
)

export default component.exports